import * as React from 'react'
import { IndicatorComponent } from './Components/Indicator'
import { IndicatorStore } from './Stores/IndicatorStore'

export const Indicator = new IndicatorStore()
type Props = {
  colorStart:string
  colorEnd:string
  backgroundColor:string
}

export const LoadingIndicator = (props:Props) => {
  return <IndicatorComponent {...props} indicatorStore={Indicator}/>
}